import React, { useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { LHIC_CONTENT } from '../data/lhicContent';

export default function LhicModal({ isOpen, onClose }) {
  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === 'Escape') onClose();
    },
    [onClose]
  );

  useEffect(() => {
    if (!isOpen) return undefined;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, handleKeyDown]);

  if (!isOpen) return null;

  return (
    <div
      className="lhic-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="lhic-modal-title"
      onClick={onClose}
    >
      <button
        type="button"
        className="project-modal__close"
        onClick={onClose}
        aria-label="Close"
      >
        ×
      </button>
      <div className="lhic-modal__panel" onClick={(e) => e.stopPropagation()}>
        <h2 id="lhic-modal-title" className="lhic-modal__title">
          {LHIC_CONTENT.title}
        </h2>

        <div className="lhic-modal__body">
          <div className="lhic-modal__image">
            <img src={LHIC_CONTENT.modalImage} alt={LHIC_CONTENT.modalImageAlt} />
          </div>

          <div className="lhic-modal__text">
            <p>{LHIC_CONTENT.intro}</p>

            <h3 className="lhic-modal__highlights-heading">Key Highlights</h3>
            <ul className="lhic-modal__highlights">
              {LHIC_CONTENT.highlights.map((item) => (
                <li key={item.label}>
                  <strong>{item.label}:</strong> {item.text}
                </li>
              ))}
            </ul>

            <p>{LHIC_CONTENT.closing}</p>
          </div>
        </div>

        <div className="lhic-modal__footer">
          <Link to="/lhic" className="bnt bnt-theme" onClick={onClose}>
            Know More
          </Link>
        </div>
      </div>
    </div>
  );
}
